import { useSnackbar } from "$utils/useSnackbar";

import { Product } from "$containers";
import { Text, Modal } from "$components";
import useJStyles from "$hooks/useJStyles";
import useModals from "../hooks/useModals";
import EdbAddOpPopin from "../../EdbAddOpPopin";
import { PreparationOrderStatus } from "$types";
import { snackbarSuccessOptions } from "$utils/SnackbarOptions";
import ModalDeleteProductEdb from "../../ModalDeleteProductEdb";
import { useProfileEDBContext } from "../context/ProfileEDBContext";
import ModalSubstituteProduct from "$components/EDB/ModalSubstituteProduct";
import ApprovalModal from "./ApprovalModal";

export default function ProfileEDBModals() {
  const { jclasses } = useJStyles();
  const [openSnackbar] = useSnackbar(snackbarSuccessOptions);

  const {
    edb,
    idEdb,
    opList,
    isLoading,
    isDeleteEdb,
    isCancelEdb,
    isDuplicateEdb,
    productPopin,
    productToDeleteId,
    productEdbAddToOP,
    openCartModalValidate,
    openModalCreateNewEdb,
    openModalDeleteProduct,
    productToDeleteFromEdb,
    selectedSubstituteProduct,
    openModalSubstituteProduct,
    openModalDeleteMultipleProduct,
    isApprovalModalOpen,
    setIsApprovalModalOpen,

    // Functions
    setShowCart,
    setIsLoading,
    onValidateCart,
    resetProductPopin,
    substituteProduct,
    onDeleteItemFromEdb,
    setProductEdbAddToOP,
    validateProductAddToOp,
    substitutionProductEDB,
    setOpenModalCreateNewEdb,
    setOpenCartModalValidate,
    setOpenModalDeleteProduct,
    setDisplayDeliveryModality,
    setProductToDeleteFromEdb,
    setOpenModalSubstituteProduct,
    setOpenModalDeleteMultipleProduct,
  } = useProfileEDBContext();

  const {
    deleteProduct,
    handleDeleteEdb,
    handleCancelEdb,
    handleDuplicateEdb,
    getDeliveryModality,
    deleteMultipleProduct,
    handleCancelDeleteEdb,
    handleCancelCancelEdb,
    handleCancelDuplicateEdb,
    getWordingProductToDelete,
    getInformationDeliveryAddress,
  } = useModals();

  return (
    <>
      <EdbAddOpPopin
        productAddToOp={productEdbAddToOP}
        resetProduct={() => setProductEdbAddToOP(null)}
        opList={opList.filter(
          (op: any) => op.status === PreparationOrderStatus.CREATED
        )}
        validateProductAddToOp={validateProductAddToOp}
      />

      <ModalDeleteProductEdb
        product={productToDeleteFromEdb}
        resetProduct={() => setProductToDeleteFromEdb(null)}
        validateDeleteProduct={onDeleteItemFromEdb}
        idEdb={idEdb}
      />
      <ModalSubstituteProduct
        currentCompany={edb?.company}
        isOpen={openModalSubstituteProduct}
        setOpen={setOpenModalSubstituteProduct}
        productToSubstitute={selectedSubstituteProduct}
        idEdb={idEdb}
        opList={opList}
        substituteProduct={substitutionProductEDB}
        openSnackbar={openSnackbar}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <Modal
        title="Dupliquer l'EDB"
        textValidate="Valider"
        textCancel="Annuler"
        open={isDuplicateEdb}
        onValidate={handleDuplicateEdb}
        onCancel={handleCancelDuplicateEdb}
      >
        <div className={jclasses.jDialogContent}>
          <Text style={{ whiteSpace: "pre-line" }}>
            {`Vous allez créer une nouvelle EDB en statut Brouillon à partir de cette EDB.
L'étape 1 sera vide et devra être complétée.
Souhaitez-vous continuer ?`}
          </Text>
        </div>
      </Modal>
      <Modal
        textValidate="Supprimer"
        textCancel="Annuler"
        open={isDeleteEdb}
        onValidate={handleDeleteEdb}
        onCancel={handleCancelDeleteEdb}
      >
        <div className={jclasses.jDialogContent}>
          <Text>
            Attention
            <br />
            Vous êtes sur le point de supprimer définitivement cette Expression
            de besoin.
            <br />
            Êtes-vous sûr de vouloir continuer ?
          </Text>
        </div>
      </Modal>
      <Modal
        textValidate="Oui"
        textCancel="Non"
        open={isCancelEdb}
        onValidate={handleCancelEdb}
        onCancel={handleCancelCancelEdb}
      >
        <div className={jclasses.jDialogContent}>
          <Text>
            Attention
            <br />
            Vous êtes sur le point d&apos;annuler cette Expression de besoin.
            <br />
            Êtes-vous sûr de vouloir continuer ?
          </Text>
        </div>
      </Modal>
      <Modal
        title="Confirmation de suppression"
        textValidate="Oui"
        textCancel="Non"
        open={openModalDeleteProduct}
        onValidate={async () => {
          await deleteProduct(productToDeleteId);
          setOpenModalDeleteProduct(false);
        }}
        onCancel={() => {
          setOpenModalDeleteProduct(false);
        }}
      >
        <div className={jclasses.jDialogContent}>
          <Text style={{ whiteSpace: "pre-line" }}>
            Souhaitez vous supprimer ce produit de l&apos;expression de besoin ?
          </Text>
        </div>
      </Modal>
      <Modal
        textValidate="Continuer"
        textCancel="Annuler"
        open={openModalDeleteMultipleProduct}
        onValidate={async () => {
          deleteMultipleProduct();
          setOpenModalDeleteMultipleProduct(false);
        }}
        onCancel={() => {
          setOpenModalDeleteMultipleProduct(false);
        }}
      >
        <div className={jclasses.jDialogContent}>
          <Text style={{ whiteSpace: "pre-line" }}>
            {getWordingProductToDelete()}
          </Text>
        </div>
      </Modal>
      <Modal
        textValidate="Oui"
        textCancel="Non"
        open={openCartModalValidate}
        onValidate={onValidateCart}
        onCancel={() => {
          setOpenCartModalValidate(false);
          setOpenModalCreateNewEdb(true);
        }}
      >
        <div className={jclasses.jDialogContent}>
          <Text style={{ whiteSpace: "pre-line" }}>
            {`
                 Souhaitez vous conserver les mêmes modalités de livraison ?

                 Rappel des modalités de livraison: ${getDeliveryModality()}

                 ${getInformationDeliveryAddress()}
              `}
          </Text>
        </div>
      </Modal>
      <Modal
        textValidate="Valider"
        textCancel="Annuler"
        open={openModalCreateNewEdb}
        onValidate={() => {
          setShowCart(false);
          setOpenModalCreateNewEdb(false);
          setDisplayDeliveryModality(true);
        }}
        onCancel={() => {
          setOpenModalCreateNewEdb(false);
        }}
      >
        <div className={jclasses.jDialogContent}>
          <Text style={{ whiteSpace: "pre-line" }}>
            Vous souhaitez renseigner des modalités de livraison différentes de
            l&apos;EDB initiale.
            <br />
            Une nouvelle EDB va donc être créée.
            <br />
            Veuillez spécifier les nouvelles modalités de livraison.
          </Text>
        </div>
      </Modal>
      <Product
        // substituteCtaLabel="Remplacer par produit de substitution :"
        noCart
        product={productPopin}
        resetProduct={resetProductPopin}
        edb={idEdb}
        substituteProduct={substituteProduct}
      />

      <ApprovalModal
        open={isApprovalModalOpen}
        onClose={() => setIsApprovalModalOpen(false)}
      />
    </>
  );
}
